var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$screen.width >= 1040)?_c('aside',{staticClass:"feed-aside feed-column"},[_c('AdminMenu')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }